module.exports = __webpack_public_path__ + "img/desktop-neck-6_300x18.c2cb7760.png";